import { JpClassTypeDTO } from "../dto/classes/JpClassTypeDTO";
import { JpClassType } from "../models/Classes/JpClassType";
import { useUtility } from "@/composables/useUtility";

export const jpClassTypeMapper = (dto: JpClassTypeDTO) => {
  const { mapPseudoBool } = useUtility();

  return new JpClassType({
    id: dto.typeId,
    name: dto.typeName,
    signupMax: dto.signupMax,
    allowMultiple: mapPseudoBool(dto.allowMultiple) || false,
    prerequisite: dto.ratingPrereq,
    sessionLength: dto.sessionLength,
    sessionCount: dto.sessionCt,
    ratingOverkill: dto.ratingOverkill,
    minAge: dto.minAge,
    maxAge: dto.maxAge,
    minSessionsForAttended: dto.minSessionsForAttended,
    active: mapPseudoBool(dto.active) || false,
    displayOrder: dto.displayOrder,
    noLimit: mapPseudoBool(dto.noLimit) || false,
  });
};
